export const getAjustedItemSize = (activeIndex: number, itemIndex: number, adjust: number) => {
    if (adjust === 1) return 1;

    const offset = Math.abs(activeIndex - itemIndex);
    let add = (adjust - 1) * ((1 - offset) / 1);
    if (add < 0) add = 0;
    return 1 + add;
};
